
const Reducer = (state, action) => {
    switch (action.type) {
        case 'SET_FEEDS':
            return {
                ...state,
                feeds: action.payload
            };
        case 'LIKE_FEED':
            return {
                ...state,
                feeds: state.feeds.map(feed => { 
                    if(feed._id === action.payload._id) {
                        let extract = feed.likes.filter(like => like.buyer_id !== action.payload.data.buyer_id)
                        extract.push(action.payload.data)
                        feed.likes = extract
                    }
                    return feed
                })
            };
        case 'UNLIKE_FEED':
            let newState = state.feeds.map(
                feed => { 
                    if(feed._id === action.payload._id) {
                        feed.likes = feed.likes.filter(
                                like => like.buyer_id !== action.payload.buyer_id
                            );
                        }
                    return feed 
                })

            return {
                ...state,
                feeds: newState
            };
        case 'SET_ERROR':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
};

export default Reducer;